// import { computed } from "vue";
import { mapActions, mapGetters } from "vuex";

export default {
  computed:{
    ...mapGetters({
      folderArticleSkeleton: 'folders/folderArticleSkeleton',
      folderSuggestedArticleSkeleton: 'folders/folderSuggestedArticleSkeleton',
      folderMediaSkeleton: 'folders/folderMediaSkeleton',
      activeFolder: 'folders/activeFolder',
      folderArticleContentPage: 'folders/folderArticleContentPage',
      folderMediaContentPage: 'folders/folderMediaContentPage',
      folderBookContentPage: 'folders/folderBookContentPage',
      folderPodcastContentPage: 'folders/folderPodcastContentPage',
      folderSuggestedArticlePage: 'folders/folderSuggestedArticlePage',
      selectedArchiveFolder: 'archive/selectedArchiveFolder'
    }),
    folderType(){
      return this.$route.params.class
    },
    selectedFolderId(){
      return this.$route.params?.id ?? this.selectedArchiveFolder?.id ?? ''
    },
    skeletonLoader() {

      if(this.activeTab === 'articles' || this.selectedLibraryContentType === 'articles') {
        return this.folderArticleSkeleton;
      } 
      else if (this.activeTab === 'suggested' || this.selectedLibraryContentType === 'suggested'){
        return this.folderSuggestedArticleSkeleton
      }      
      else if((this.activeTab === 'videos' || this.activeTab === 'podcasts' || this.activeTab === 'books') || (this.selectedLibraryContentType === 'videos' || this.selectedLibraryContentType === 'podcasts' || this.selectedLibraryContentType === 'books')) {
        return this.folderMediaSkeleton;
      } else {
        return false;
      }
    },

  },
  methods: {
    ...mapActions({
      incOrDecFolderContentPageCounter: 'folders/incOrDecFolderContentPageCounter',
      getFolderSuggestedArticles: 'folders/fetchFolderSuggestedArticles',
      getFolderArticleContent: 'folders/fetchFolderArticles',
      getFolderBooksContent: 'folders/fetchFolderBooks',
      getFolderMediaContent: 'folders/fetchFolderMedia',
      getFolderPodcastContent: 'folders/fetchFolderFiles',
      resetFolderArticlePage: 'folders/resetFolderArticlePage',
      resetFolderMediaPage: 'folders/resetFolderMediaPage',
      resetFolderBookPage: 'folders/resetFolderBookPage',
      resetFolderPodcastPage: 'folders/resetFolderPodcastPage',
      resetFolderSuggestedArticlePage: 'folders/resetFolderSuggestedArticlePage',
      initiateFolderSkeletonLoader: 'folders/initiateFolderSkeletonLoader',
    }),
    async createActivity(folderId, activityType, action) {
      try {
        const institute = await this.$store.getters["profile/institute"];
        const payload = {
          institute_id: institute.id,
          instance_id: folderId,
          actionDetails:{
             activity_type: activityType,
              action: action,
          },
        };
        if (this.institute && this.folderType === 'institute')
          await this.$store.dispatch("folders/createFolderActivity", payload);
      } catch (err) {
        console.log(err);
      }
    },
    resetAllContentPages(){
      this.resetFolderPodcastPage()
      this.resetFolderArticlePage()
      this.resetFolderMediaPage()
      this.resetFolderBookPage()
      this.resetFolderSuggestedArticlePage()
    }
  },
};
